import {
	createHashHistory,
	createRouter as createTanStackRouter,
} from "@tanstack/react-router";
import Loader from "./components/loader";
import { retireSplitSessions } from "./lib/firebase";
import { sentryLogger } from "./lib/sentry";
import { getActiveScope } from "./lib/socket-owner";
import { coreStore } from "./lib/stores/core-store";
import { uiStore } from "./lib/stores/ui-store";
import { routeTree } from "./routeTree.gen";

type CreateRouterOptions = {
	hash?: boolean;
};

export const createRouter = ({ hash = false }: CreateRouterOptions = {}) => {
	retireSplitSessions().catch((error) => {
		sentryLogger.warn("Could not sign out a retired split sign-in", {
			error: String(error),
		});
	});

	// D2 (TECH-2944): paint the client-side cache into core-store BEFORE the
	// first render, so /app shows the last workspace's channels instantly
	// (read-only) while the WS connects. Synchronous, because the cache rehydrates
	// from localStorage synchronously. The persisted currentWorkspaceId lives in
	// ui-store (not duplicated into the cache).
	//
	// Skipped when the tab is booting into another client. This cache is the
	// Learner Client's workspace data, and `claimSocket` clears it moments later
	// anyway, so not painting it in the first place avoids the window.
	if (getActiveScope() === "app") {
		coreStore
			.getState()
			.hydrateFromCache(uiStore.getState().currentWorkspaceId);
	}

	return createTanStackRouter({
		routeTree,
		...(hash ? { history: createHashHistory() } : {}),
		scrollRestoration: true,
		defaultPreloadStaleTime: 0,
		context: {},
		defaultPendingComponent: () => <Loader />,
		defaultNotFoundComponent: () => <div>Not Found</div>,
	});
};
